import React from "react";
import { View } from "react-native";
import { Text } from "components";

import { sizes, colors } from "assets/constants";
import css from "styles";

const Title: React.FC<{ item: FactorItemT }> = ({ item }) => {
  return (
    <>
      <View style={{ position: "absolute", top: -4, right: 0 }}>
        <Text color={colors.text.gray} size={"xs"} weight="bold">
          {item?.category?.title}
        </Text>
      </View>
      <View style={{ ...css.row, marginHorizontal: sizes.space }}>
        {item?.attributes?.length > 0 && <Text>(</Text>}
        {item?.attributes?.map((attr, key) => {
          return (
            <Text key={String(key)} weight="bold" size={"lg"}>
              {attr?.title}
              {key !== 0 && item?.attributes?.length > 1 && " , "}
            </Text>
          );
        })}
        {item?.attributes?.length > 0 && <Text>)</Text>}
      </View>

      <Text size={"xl"} weight={"bold"} color={colors.text.dark}>
        {item?.product?.title}
      </Text>
    </>
  );
};

export default Title;
